// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-group-sm .btn:not([style*="hidden"]):has(+ .btn[style*="hidden"])  {
    border-top-right-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
}
.btn-group-sm .btn[style*="hidden"] + .btn:not([style*="hidden"]) {
    border-top-left-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
}

.btn-disabled-gray .btn:disabled {
    color: #fff;
    background-color: #858796;
    border-color: #858796;
}`, "",{"version":3,"sources":["webpack://./ClientApp/css/site.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,kCAAkC;AACtC;AACA;IACI,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB","sourcesContent":[".btn-group-sm .btn:not([style*=\"hidden\"]):has(+ .btn[style*=\"hidden\"])  {\r\n    border-top-right-radius: 0.2rem;\r\n    border-bottom-right-radius: 0.2rem;\r\n}\r\n.btn-group-sm .btn[style*=\"hidden\"] + .btn:not([style*=\"hidden\"]) {\r\n    border-top-left-radius: 0.2rem;\r\n    border-bottom-left-radius: 0.2rem;\r\n}\r\n\r\n.btn-disabled-gray .btn:disabled {\r\n    color: #fff;\r\n    background-color: #858796;\r\n    border-color: #858796;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
